import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  // Signal for the current title
  public readonly pageTitle = signal<string>('');

  setTitle(pageTitle: string) {
    this.pageTitle.set(pageTitle);
  }
}